var map = {
	"./Abstract.LogisticsAction": 3023,
	"./Abstract.LogisticsAction.json": 3023,
	"./Abstract.LogisticsActivity": 6092,
	"./Abstract.LogisticsActivity.json": 6092,
	"./Abstract.LogisticsAgent": 1194,
	"./Abstract.LogisticsAgent.json": 1194,
	"./Abstract.LogisticsObject": 5910,
	"./Abstract.LogisticsObject.json": 5910,
	"./Abstract.LogisticsService": 956,
	"./Abstract.LogisticsService.json": 956,
	"./Abstract.PhysicalLogisticsObject": 8125,
	"./Abstract.PhysicalLogisticsObject.json": 8125,
	"./Action.Check": 6590,
	"./Action.Check.json": 6590,
	"./Action.Composing": 2145,
	"./Action.Composing.json": 2145,
	"./Action.Loading": 618,
	"./Action.Loading.json": 618,
	"./Action.Storing": 444,
	"./Action.Storing.json": 444,
	"./Activity.Storage": 9448,
	"./Activity.Storage.json": 9448,
	"./Activity.TransportMovement": 177,
	"./Activity.TransportMovement.json": 177,
	"./Activity.UnitComposition": 7025,
	"./Activity.UnitComposition.json": 7025,
	"./Agent.Actor": 9320,
	"./Agent.Actor.json": 9320,
	"./Agent.Carrier": 7141,
	"./Agent.Carrier.json": 7141,
	"./Agent.Company": 4182,
	"./Agent.Company.json": 4182,
	"./Agent.NonHumanActor": 1368,
	"./Agent.NonHumanActor.json": 1368,
	"./Agent.Organization": 804,
	"./Agent.Organization.json": 804,
	"./Agent.Person": 2154,
	"./Agent.Person.json": 2154,
	"./Agent.PublicAuthority": 487,
	"./Agent.PublicAuthority.json": 487,
	"./BillingSettlement.BillingDetails": 1559,
	"./BillingSettlement.BillingDetails.json": 1559,
	"./Common.Answer": 1333,
	"./Common.Answer.json": 1333,
	"./Common.CheckTemplate": 4655,
	"./Common.CheckTemplate.json": 4655,
	"./Common.CheckTotalResult": 3256,
	"./Common.CheckTotalResult.json": 3256,
	"./Common.ExternalReference": 9485,
	"./Common.ExternalReference.json": 9485,
	"./Common.IotDevice": 4599,
	"./Common.IotDevice.json": 4599,
	"./Common.LoadingMaterial": 9828,
	"./Common.LoadingMaterial.json": 9828,
	"./Common.LoadingUnit": 7875,
	"./Common.LoadingUnit.json": 7875,
	"./Common.Location": 624,
	"./Common.Location.json": 624,
	"./Common.Question": 6531,
	"./Common.Question.json": 6531,
	"./Common.Sensor": 6973,
	"./Common.Sensor.json": 6973,
	"./Core.CO2Emissions": 1417,
	"./Core.CO2Emissions.json": 1417,
	"./Core.CustomsInformation": 3223,
	"./Core.CustomsInformation.json": 3223,
	"./Core.Insurance": 5883,
	"./Core.Insurance.json": 5883,
	"./Core.Item": 4558,
	"./Core.Item.json": 4558,
	"./Core.PackagingType": 5304,
	"./Core.PackagingType.json": 5304,
	"./Core.Piece": 4301,
	"./Core.Piece.json": 4301,
	"./Core.Product": 9424,
	"./Core.Product.json": 9424,
	"./Core.SecurityDeclaration": 8341,
	"./Core.SecurityDeclaration.json": 8341,
	"./Core.Shipment": 767,
	"./Core.Shipment.json": 767,
	"./Core.TransportMeans": 4600,
	"./Core.TransportMeans.json": 4600,
	"./Core.ULD": 6396,
	"./Core.ULD.json": 6396,
	"./Core.Waybill": 8817,
	"./Core.Waybill.json": 8817,
	"./DG.DgDeclaration": 4714,
	"./DG.DgDeclaration.json": 4714,
	"./DG.DgProductRadioactive": 1962,
	"./DG.DgProductRadioactive.json": 1962,
	"./DG.DgRadioactiveIsotope": 634,
	"./DG.DgRadioactiveIsotope.json": 634,
	"./DG.ItemDg": 8257,
	"./DG.ItemDg.json": 8257,
	"./DG.PieceDg": 3362,
	"./DG.PieceDg.json": 3362,
	"./DG.ProductDg": 3359,
	"./DG.ProductDg.json": 3359,
	"./Distribution.BookingOption": 816,
	"./Distribution.BookingOption.json": 816,
	"./Distribution.BookingOptionRequest": 6682,
	"./Distribution.BookingOptionRequest.json": 6682,
	"./Distribution.BookingRequest": 2042,
	"./Distribution.BookingRequest.json": 2042,
	"./Distribution.BookingShipment": 5607,
	"./Distribution.BookingShipment.json": 5607,
	"./Distribution.Price": 9659,
	"./Distribution.Price.json": 9659,
	"./Distribution.Ratings": 8112,
	"./Distribution.Ratings.json": 8112,
	"./Distribution.TransportLegs": 2106,
	"./Distribution.TransportLegs.json": 2106,
	"./Embedded.ActivitySequence": 722,
	"./Embedded.ActivitySequence.json": 722,
	"./Embedded.Address": 5326,
	"./Embedded.Address.json": 5326,
	"./Embedded.Adjustments": 6954,
	"./Embedded.Adjustments.json": 6954,
	"./Embedded.BookingPreferences": 725,
	"./Embedded.BookingPreferences.json": 725,
	"./Embedded.BookingTimes": 8637,
	"./Embedded.BookingTimes.json": 8637,
	"./Embedded.CarrierProduct": 5309,
	"./Embedded.CarrierProduct.json": 5309,
	"./Embedded.Characteristic": 3143,
	"./Embedded.Characteristic.json": 3143,
	"./Embedded.CodeListElement": 2949,
	"./Embedded.CodeListElement.json": 2949,
	"./Embedded.ContactDetail": 5075,
	"./Embedded.ContactDetail.json": 5075,
	"./Embedded.CurrencyValue": 3434,
	"./Embedded.CurrencyValue.json": 3434,
	"./Embedded.Dimensions": 7099,
	"./Embedded.Dimensions.json": 7099,
	"./Embedded.Geolocation": 356,
	"./Embedded.Geolocation.json": 356,
	"./Embedded.LoosePiece": 1282,
	"./Embedded.LoosePiece.json": 1282,
	"./Embedded.Measurement": 1954,
	"./Embedded.Measurement.json": 1954,
	"./Embedded.MovementTime": 4742,
	"./Embedded.MovementTime.json": 4742,
	"./Embedded.OtherCharge": 7892,
	"./Embedded.OtherCharge.json": 7892,
	"./Embedded.OtherIdentifier": 4355,
	"./Embedded.OtherIdentifier.json": 4355,
	"./Embedded.Party": 5802,
	"./Embedded.Party.json": 5802,
	"./Embedded.PieceGroup": 8687,
	"./Embedded.PieceGroup.json": 8687,
	"./Embedded.Ranges": 5284,
	"./Embedded.Ranges.json": 5284,
	"./Embedded.RegulatedEntity": 3046,
	"./Embedded.RegulatedEntity.json": 3046,
	"./Embedded.StationRemarks": 2999,
	"./Embedded.StationRemarks.json": 2999,
	"./Embedded.TemperatureInstructions": 4213,
	"./Embedded.TemperatureInstructions.json": 4213,
	"./Embedded.ULDBasicPiece": 1345,
	"./Embedded.ULDBasicPiece.json": 1345,
	"./Embedded.ULDSpecificPiece": 2613,
	"./Embedded.ULDSpecificPiece.json": 2613,
	"./Embedded.UnitsPreference": 6244,
	"./Embedded.UnitsPreference.json": 6244,
	"./Embedded.Value": 771,
	"./Embedded.Value.json": 771,
	"./Embedded.VolumePieceGroup": 197,
	"./Embedded.VolumePieceGroup.json": 197,
	"./Embedded.VolumetricWeight": 894,
	"./Embedded.VolumetricWeight.json": 894,
	"./Embedded.WaybillLineItem": 1669,
	"./Embedded.WaybillLineItem.json": 1669,
	"./Event.LogisticsEvent": 8941,
	"./Event.LogisticsEvent.json": 8941,
	"./LiveAnimals.EpermitConsignment": 6140,
	"./LiveAnimals.EpermitConsignment.json": 6140,
	"./LiveAnimals.EpermitSignature": 1391,
	"./LiveAnimals.EpermitSignature.json": 1391,
	"./LiveAnimals.LiveAnimalsEpermit": 388,
	"./LiveAnimals.LiveAnimalsEpermit.json": 388,
	"./LiveAnimals.PieceLiveAnimals": 7216,
	"./LiveAnimals.PieceLiveAnimals.json": 7216,
	"./Service.Booking": 2896,
	"./Service.Booking.json": 2896
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8673;